import {
    Button,
    Card,
    CardBody,
    FormGroup,
    Form,
    Col,
    FormFeedback,
    Label,
} from "reactstrap";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { useDispatch, useSelector } from 'react-redux';
import { userActions } from '../../redux/actions';
import { useHistory } from "react-router-dom";
import { theme } from "utils/theme";
import { Link } from "react-router-dom";

const loginSchema = yup.object().shape({
    phone: yup.string().length(10, 'Phone number must be 10 digit'),
});

const Login = () => {
    const { register, handleSubmit, formState: { errors } } = useForm({ resolver: yupResolver(loginSchema) });
    const dispatch = useDispatch();
    const loggingIn = useSelector(state => state.loginReducer.loggingIn);
    const history = useHistory();

    function onLoginSubmit(data) {
        data.country_code = '91'
        data.role = 4
        dispatch(userActions.login(data, history));
    }

    return (
        // <Card>
        <div className="px-lg-5 py-lg-5">
            <div className="text-center text-muted mb-4">
                <img
                    style={{
                        width: 50,
                        height: 50,
                        borderRadius: 50,
                        objectFit: "contain"
                    }}
                    alt="..."
                    src={require("./../../assets/img/brand/playstore-icon.png").default}
                />
                <h3 style={{color:"#5E5873",fontSize:"18px"}} className="mt-2 Montserrat-500">Welcome back to Ryzer Channel Partner Portal 👋</h3>
                <span className="text-center Montserrat-400" style={{color:"#6E6B7B"}}>Please login from your mobile number</span>
            </div>
            <Form role="form" onSubmit={handleSubmit(onLoginSubmit)}>
                <FormGroup>
                    <Label for="phone" className="Montserrat-400"> Mobile Number </Label>
                    <input
                        placeholder="Enter your mobile number"
                        {...register('phone')} className={`form-control ${errors.phone ? 'is-invalid' : ''}`} id="phone" />
                    <FormFeedback> {errors.phone?.message} </FormFeedback>
                </FormGroup>
                <div className="text-center">
                    <Button type="submit"
                        className="my-1 w-100 rz-button-primary"
                    // disabled={loggingIn}
                    >
                        {'Sign in'}
                    </Button>
                </div>
            </Form>
            <div className="text-center  mb-4">
                <p className="mt-2 " style={{color:"#5E5873"}}>
                    Don’t have an account?
                    <Link
                        className='Montserrat-400'
                        to="/auth/register"
                        style={{
                            cursor: "pointer",
                            marginLeft: 4
                        }}>
                        <span className="ryzer-text-primary Montserrat-500">Signup here</span>
                    </Link>
                </p>
            </div>
        </div>
        // </Card>
    );
};

export default Login;
